import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {FinalDokumenComponent} from "./final-dokumen.component";

const routes: Routes = [
  {
    path: 'final-dokumen',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: FinalDokumenComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinalDokumenRoutingModule { }
